__turbopack_context__.v({
  "container": "ArticleTemplate-module__c6pkgG__container",
  "date": "ArticleTemplate-module__c6pkgG__date",
  "fadeInItems": "ArticleTemplate-module__c6pkgG__fadeInItems",
  "label": "ArticleTemplate-module__c6pkgG__label",
  "model": "ArticleTemplate-module__c6pkgG__model",
  "name": "ArticleTemplate-module__c6pkgG__name",
  "names": "ArticleTemplate-module__c6pkgG__names",
  "sidebar": "ArticleTemplate-module__c6pkgG__sidebar",
  "sidebarContent": "ArticleTemplate-module__c6pkgG__sidebarContent",
  "spacing--lg": "ArticleTemplate-module__c6pkgG__spacing--lg",
  "spacing--md": "ArticleTemplate-module__c6pkgG__spacing--md",
  "spacing--sm": "ArticleTemplate-module__c6pkgG__spacing--sm",
  "spacing--xl": "ArticleTemplate-module__c6pkgG__spacing--xl",
  "spacing--xs": "ArticleTemplate-module__c6pkgG__spacing--xs",
  "spacing--xxl": "ArticleTemplate-module__c6pkgG__spacing--xxl",
  "spacing--xxs": "ArticleTemplate-module__c6pkgG__spacing--xxs",
  "spacing--xxxl": "ArticleTemplate-module__c6pkgG__spacing--xxxl",
  "spacing--xxxs": "ArticleTemplate-module__c6pkgG__spacing--xxxs",
  "tag": "ArticleTemplate-module__c6pkgG__tag",
  "tags": "ArticleTemplate-module__c6pkgG__tags",
  "title": "ArticleTemplate-module__c6pkgG__title",
  "wrapper": "ArticleTemplate-module__c6pkgG__wrapper",
});
